import gql from 'graphql-tag';

export const printPartnerOrderServiceDetails = gql`
  fragment printPartnerOrderServiceDetails on PrintPartnerOrderService {
    id
    print_partner {
      id
      name
    }
    print_order_service {
      id
      name
      description
    }
    price {
      value
      currency
    }
    min_price {
      value
      currency
    }
    print_partner_price {
      value
      currency
    }
  }
`;

export const printPartnerShippingOptionDetails = gql`
  fragment printPartnerShippingOptionDetails on PrintPartnerShippingOption {
    id
    name
    description
    shipping_method
  }
`;

export const accountPrintPartnerShippingOptionDetails = gql`
  fragment accountPrintPartnerShippingOptionDetails on AccountPrintPartnerShippingOption {
    id
    shipping_price {
      value
      currency
    }
    print_partner_shipping_option {
      ...printPartnerShippingOptionDetails
    }
  }
  ${printPartnerShippingOptionDetails}
`;
